import React, { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { lazyImport } from 'utils/basic.js'
import LoadingView from 'components/LoadingView'

const Care = lazyImport(() => import('views/Care'))
const IdentityReturn = lazyImport(() => import('views/Care/MCA/IdentityReturn'))
const Signup = lazyImport(() => import('views/Care/Signup'))
const AboutYou = lazyImport(() => import('views/Care/AboutYou'))
const CheckEmail = lazyImport(() => import('views/Care/CheckEmail'))
const ForgetPassword = lazyImport(() => import('views/Care/ForgetPassword'))
const McaAssessment = lazyImport(() => import('views/Care/MCA/McaAssessment'))

const AppRoutes = () => {
  return (
    <Suspense fallback={<LoadingView />}>
      <Routes>
        <Route
          path='/medicare-access/identity/return'
          element={<IdentityReturn />}
        />
        <Route path='/signup' element={<Signup />} />
        <Route path='/login' element={<Signup isSignup={false} />} />
        <Route path='/about-you' element={<AboutYou />} />
        {/* Optional variant segment: plain /checkemail for in-app entries
            (failed login, /forget), /checkemail/<variant>?r=magiclink/<code>
            as the magic-link landing from the FitOn email (plan Step 7). The
            segment is whatever SKU variant the backend put in the URL (mca
            today) — CheckEmail threads it through, no per-variant route
            needed. */}
        <Route path='/checkemail/:variant?' element={<CheckEmail />} />
        <Route path='/forget' element={<ForgetPassword />} />
        {/* Not wrapped in PrivateRoute: a logged-out visit needs to keep its
            fitonUserId/variant query params (PrivateRoute's bare
            Navigate('/') drops them) and needs its own MSK-alignment check,
            not just a token check. McaAssessment.js owns that guard itself
            (see its access-check effect). */}
        <Route path='/medicare-access/assessment' element={<McaAssessment />} />
        <Route path='/' element={<Care />} />
        <Route path='*' element={<Care />} />
      </Routes>
    </Suspense>
  )
}

export default AppRoutes
